/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconFilePencil = createReactComponent("outline", "file-pencil", "IconFilePencil", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M10 18l5 -5a1.414 1.414 0 0 0 -2 -2l-5 5v2h2z", "key": "svg-2" }]]);

export { IconFilePencil as default };
//# sourceMappingURL=IconFilePencil.mjs.map
